var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGlobeLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.337,
    height: 13.335,
    viewBox: "0 0 13.337 13.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-Globe-Line",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.667,13.334a6.666,6.666,0,1,1,6.16-4.116A6.675,6.675,0,0,1,6.667,13.334Zm0-12A5.33,5.33,0,1,0,12,6.667,5.339,5.339,0,0,0,6.665,1.336Z",
    fill: "#BDC6D7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    d: "M3.333,13.333C1.5,13.333,0,10.343,0,6.667S1.5,0,3.333,0,6.666,2.99,6.666,6.666,5.171,13.333,3.333,13.333Zm0-12c-.057,0-.574.034-1.164,1.216a9.561,9.561,0,0,0-.836,4.118,9.553,9.553,0,0,0,.836,4.118C2.758,11.966,3.276,12,3.333,12s.574-.034,1.167-1.216a9.559,9.559,0,0,0,.836-4.117A9.559,9.559,0,0,0,4.5,2.549C3.907,1.367,3.39,1.333,3.333,1.333Z",
    transform: "translate(3.334 0.001)",
    fill: "#BDC6D7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    d: "M13.3,1.333q.033-.329.033-.667A6.65,6.65,0,0,0,13.3,0H.033Q0,.329,0,.667t.033.667Z",
    transform: "translate(0 6.001)",
    fill: "#BDC6D7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGlobeLine);
export default __webpack_public_path__ + "static/media/icons-Globe-Line.93168e4ce58c2c5483c5b5603aab7ce5.svg";
export { ForwardRef as ReactComponent };